<div class="d-flex flex-column align-items-center overflow-hidden">
    <button *adaptIfAuthorised="EditStrategicAnchors; else featureNotEnabled"
            class="btn btn-primary"
            [adaptBlockingClick]="gotoAnchorsPage">Record strategic anchors</button>
    <ng-template #featureNotEnabled>
        <span>This feature is enabled only for the Scale+ platform subscription.</span>
    </ng-template>
</div>
